import { Component, OnInit } from '@angular/core';
import {redirectPage, resetSessionVariable} from "../../../data.service";
import {ConfigApp} from "../../../config";
import * as $ from "jquery";

@Component({
  selector: 'app-page-logout',
  templateUrl: './page-logout.component.html'
})
export class PageLogoutComponent implements OnInit {
  config = ConfigApp;

  ngOnInit() {
    $(".content-page").css("margin-left","0");
    $(".content-page").css("padding","70px 0");
    resetSessionVariable()
    //return redirectPage("login");

    //if(ConfigApp.debug && ConfigApp.appId){
      return redirectPage("login");
    //}
  }

}
